/** Английские служебные тексты, которые не должны попадать в интерфейс. */
const TECHNICAL_RESPONSE = /^(internal server error|network error|bad gateway|service unavailable)$/i;

/**
 * Достаёт человекочитаемую причину ошибки из axios-исключения: текст
 * валидации от ValidationPipe (message — массив строк), сообщение
 * HttpException бэкенда, либо сетевую ошибку, если ответа не было вовсе.
 * Нужен там, где раньше показывался один и тот же алерт независимо от
 * причины (400/403/500/обрыв сети) — так причину видно сразу.
 *
 * Если передан fallback, служебные ответы заменяются на него: 5xx Nest отдаёт
 * как «Internal server error», axios при обрыве — как «Network Error». В
 * модалке оплаты такой текст ничего не объясняет (причина всё равно ищется в
 * логах по paymentId), а человеку нужно понимать, что делать дальше.
 */
export const extractErrorDetail = (err: unknown, fallback?: string): string => {
  const response = (
    err as {
      response?: { status?: number; data?: { message?: string | string[] } };
    }
  )?.response;

  if (!response) {
    return fallback || (err as { message?: string })?.message || "нет ответа от сервера, проверьте соединение";
  }

  const message = response.data?.message;
  const detail = Array.isArray(message) ? message.join("; ") : message;

  if (fallback && (response.status ?? 0) >= 500) {
    return fallback;
  }

  if (fallback && TECHNICAL_RESPONSE.test(detail ?? "")) {
    return fallback;
  }

  return detail || `сервер ответил ошибкой ${response.status}`;
};
